import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.svg";

const Container = tw.div`relative `;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-96 lg:mt-12`,
]);
const TextContent = tw.div`lg:py-1 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`
const Textarea = styled(Input).attrs({as: "textarea"})`
  ${tw`h-24`}
`

const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`

export default ({
  subheading = "Contáctanos",
  heading = <>¿Tienes una idea en mente? </>,
  description = "Hablemos para convertirla en realidad con tecnología, creatividad y el impulso que necesita para crecer.",
  submitButtonText = "Enviar",
  textOnLeft = true,
}) => {
  // La propiedad booleana textOnLeft se puede usar para mostrar el texto a la izquierda o derecha de la imagen.

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const email = form.email.value;
    const name = form.name.value;
    const subject = form.subject.value;
    const message = form.message.value;
    const plantilla = `Hola, mi nombre es ${name}.\nCorreo: ${email}\nAsunto: ${subject}\nMensaje: ${message}`;
    const numero = '3009788406';
    const url = `https://wa.me/57${numero}?text=${encodeURIComponent(plantilla)}`;
    window.open(url, '_blank');
  };

  return (
    <Container id='contact'>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} alt={`${subheading}`} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
            <Form onSubmit={handleSubmit}>
              <Input type="email" name="email" placeholder="Tu correo electrónico" required />
              <Input type="text" name="name" placeholder="Nombre completo" required />
              <Input type="text" name="subject" placeholder="Asunto" required />
              <Textarea name="message" placeholder="Tu mensaje aquí" required />
              <SubmitButton type="submit">{submitButtonText}</SubmitButton>
            </Form>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
